<template>
  <div class="material">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>审核</BreadcrumbItem>
          <BreadcrumbItem>展商审核</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">展商审核列表</div>
        <Input search placeholder="请输入关键字" v-model="search" @on-search="searchPro" style="width:230px;margin-top:20px;" />
        <div class="header-tool-utils">
          批量操作：
          <Poptip confirm title="确认批量审核?" @on-ok="setAllAudit">
            <Button type="primary" ghost>批量审核</Button>
          </Poptip>
        </div>
      </div>
    </div>
    <div class="layout-content" style="background: transparent;">
      <div v-if="list.length">
        <Table ref="selection" :columns="columns" :data="list" @on-selection-change="changeEvent" style="background: #fff;min-height:500px;">
          <template slot-scope="{ row }" slot="companyName">{{row.companyName}}</template>
          <template slot-scope="{ row }" slot="companyNameEn">{{row.companyNameEn}}</template>

          <template slot-scope="{ row }" slot="booths">
            <span v-if="row.booths && Object.prototype.toString.call(row.booths) === '[object Object]'">
              <span v-if="row.booths.hall">{{row.booths.hall}}</span>
              <span v-if="row.booths.code">{{row.booths.code}}</span>
            </span>
            <span v-else-if="row.booths && Object.prototype.toString.call(row.booths) === '[object Array]'">
              <span v-if="row.booths[0] && row.booths[0].hall">{{row.booths[0].hall}}</span>
              <span v-if="row.booths[0] && row.booths[0].code">{{row.booths[0].code}}</span>
            </span>
            <span v-else>无</span>
          </template>

          <template slot-scope="{ row }" slot="submitTime">
            <span v-if="row.submitTime">{{row.submitTime | moment("YYYY/MM/DD")}}</span>
          </template>

          <template slot-scope="{ row }" slot="edit">
            <a href="javascript:;" @click="$router.push(`/host/index/audit/info?id=${row.joinId}&name=${encodeURI(row.companyName)}`)">查看详情</a>
          </template>
          <template slot-scope="{ row }" slot="audit">
            <Poptip confirm title="确认审核吗?" @on-ok="setAudit(row)" placement="left" v-if="row.hasCheckPending">
              <a href="javascript:;">一键审核</a>
            </Poptip>
            <a href="javascript:;" style="color: #ccc;cursor: default;" v-else>一键审核</a>
          </template>
        </Table>
        <div class="my-page" v-if="totalCount > pageSize" style="margin: 20px;text-align: center;">
          <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount" @on-change="changePage" @on-page-size-change="changePageSize" />
        </div>
      </div>
      <div class="u-empty" v-else>暂无数据</div>
    </div>
    <!-- 修改展商置顶 -->
  </div>
</template>

<script> 
import { mapGetters, mapActions } from "vuex";

export default {
  name: "host-audit-list",
  data () {
    return {
      editBrand: false,
      editBrandnfo: null,
      editTopic: false,
      editTopicnfo: null,
      search: "",
      editInfo: null,
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "公司名称",
          slot: "companyName",
          align: "center",
          width: 220
        },
        {
          title: "公司英文名称",
          slot: "companyNameEn",
          align: "center",
          width: 200
        },
        {
          title: "展位号",
          slot: "booths",
          align: "center"
        },
        {
          title: "提交时间",
          slot: "submitTime",
          align: "center"
        },
        {
          title: "操作",
          slot: "edit",
          align: "center"
        },
        {
          title: "审核",
          slot: "audit",
          align: "center"
        }
      ],
      list: [],
      selection: [] // 选中项目
    };
  },
  computed: {
    ...mapGetters({
      exhibitionInfo: "hostSetModule/getHostExhibition"
    }),
    option () {
      return {
        exhibitionId: this.exhibitionInfo.id,
        keyword: this.search,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      };
    }
  },
  created () {
    this.init();
  },
  methods: {
    ...mapActions({
      getAuditList: "hostAuditModule/getAuditList",
      setOneStepAudit: "hostAuditModule/setOneStepAudit",
    }),
    async init () {
      let proData = await this.getAuditList(this.option);
      if (proData) {
        proData.items.map(c => {
          if (c.categories) {
            c.categories = JSON.parse(c.categories);
          } else {
            c.categories = [];
          }
          if (c.boothInfo) {
            c.boothInfo = JSON.parse(c.boothInfo);
          } else {
            c.boothInfo = [];
          }
        });
        this.list = proData.items;
        this.pageSize = proData.pageSize;
        this.pageIndex = proData.pageIndex;
        this.totalCount = proData.totalCount;
      }
    },
    async setAudit (row) {
      const opt = {
        joinIds: [row.joinId]
      };
      const bool = await this.setOneStepAudit(opt);
      if (bool && bool.successed) {
        this.$Message.success("操作成功");
        this.init();
      } else {
        this.$Message.error("操作失败，请重新尝试");
      }
    },
    async setAllAudit () {
      const reqList = [];
      if (!this.selection.length) return;
      this.selection.forEach(c => {
        reqList.push(c.joinId);
      });
      const bool = await this.setOneStepAudit({
        joinIds: reqList
      });
      if (bool && bool.successed) {
        this.$Message.success("操作成功");
        this.init();
      } else {
        this.$Message.error("操作失败，请重新尝试");
      }
    },
    changePage (e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize (e) {
      this.pageSize = e;
      this.init();
    },
    edit (item) {
      this.editInfo = item;
    },
    searchPro () {
      this.pageIndex = 1;
      this.init();
    },
    changeEvent (selection) {
      this.selection = selection;
    }
  }
};
</script>

<style scoped lang="scss">
.header-tool-utils {
  margin-top: 20px;
  button {
    margin-right: 20px;
  }
}
.logo {
  width: 60px;
  height: 60px;
  display: inline-block;
}
</style>

